module.exports = __webpack_public_path__ + "img/DE01059.7dcdc706.png";